export default __webpack_public_path__ + "static/media/comingsoon.fa602075.png";